<template>
  <div class="q-mt-lg">
    <div class="q-ml-lg q-my-md text-weight-medium" style="font-size: 16px">
      <div>
        <span class="text-brand-5"> Pedido: </span>
        <span class="text-brand-1">{{ title.pedido }}</span>
        <span class="text-brand-1">{{ ` | ${title.vendorName}` }}</span>
        <span class="text-brand-5"> - Criado Em: </span>
        <span class="text-brand-1">{{ title.criadoEm }}</span>
        <span class="text-brand-5"> Status: </span>
        <span class="text-brand-1">{{ title.status }}</span>
      </div>
    </div>
    <q-table
      flat
      :rows="rows"
      :columns="columns"
      table-header-style="background-color: #d9effc"
      :loading="disable"
      dense
      hide-pagination
      class="tabela-tamanho-fixo"
      v-model:pagination="pagination"
      :rows-per-page-options="[0]"
      @request="handleRequest"
    >
      <template #body-cell-comentario="props">
        <q-td>
          <q-input
            dense
            v-model="props.row.comentario"
            outlined
            label="Comentario"
            :disable="edicaoBloqueada"
          />
        </q-td>
      </template>

      <template #body-cell-remover="props">
        <q-td>
          <q-btn
            @click="remover(props.row.pivot.uuid)"
            round
            flat
            color="negative"
            icon="sym_o_delete"
            :disable="edicaoBloqueada"
          >
            <q-tooltip v-if="edicaoBloqueada">
              Edição bloqueada: pedido possui contrato vinculado
            </q-tooltip>
          </q-btn>
        </q-td>
      </template>

      <template #body-cell-infos="props">
        <q-td>
          <div class="row rap">
            <q-btn
              @click="logs(props.row.id)"
              round
              class="q-ml-sm"
              color="secondary"
              icon="visibility"
            />

            <q-btn
              @click="jobs(props.row.id)"
              round
              class="q-ml-sm"
              color="positive"
              icon="expand_less"
            />
          </div>
        </q-td>
      </template>

      <template #body-cell-contrato="props">
        <q-td>
          <q-toggle
            color="primary"
            :val="props.row.pivot.uuid"
            :disable="disableToggle || edicaoBloqueada"
            v-model="ativos"
            @click="active(props.row, $event)"
          >
            <q-tooltip v-if="edicaoBloqueada">
              Edição bloqueada: pedido possui contrato vinculado
            </q-tooltip>
          </q-toggle>
        </q-td>
      </template>
      <template #body-cell-previsao_atualizada_entrega="props">
        <q-td>
          <span
            v-if="
              props.row.editAtualizada == false ||
              props.row.editAtualizada == undefined
            "
            >{{
              props.row?.pivot?.previsao_atualizada_entrega
                ?.split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}</span
          >
          <q-input
            style="min-width: 180px"
            v-model="dataEntregaAtualizada"
            dense
            outlined
            class="input"
            placeholder="DD/MM/AAAA"
            mask="##/##/####"
            v-if="props.row.editAtualizada"
            :disable="edicaoBloqueada"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    v-model="dataEntregaAtualizada"
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>

          <q-btn
            v-if="props.row.pivot.amount != props.row.pivot.amount_received"
            @click="
              props.row.editAtualizada
                ? editarProdutos(props.row, dataEntregaAtualizada)
                : (props.row.editAtualizada = true),
                (dataEntregaAtualizada =
                  props.row?.pivot?.previsao_atualizada_entrega
                    ?.split(' ')[0]
                    .split('-')
                    .reverse()
                    .join('/'))
            "
            round
            flat
            :color="props.row.editAtualizada ? 'positive' : 'primary'"
            :disable="props.row.pivot.amount == props.row.pivot.amount_received || edicaoBloqueada"
            :icon="
              props.row.editAtualizada ? 'sym_o_done_outline' : 'sym_o_edit'
            "
          >
            <q-tooltip v-if="edicaoBloqueada">
              Edição bloqueada: pedido possui contrato vinculado
            </q-tooltip>
          </q-btn>
          <q-btn
            v-else
            style="cursor: not-allowed"
            round
            flat
            color="negative"
            disable
            icon="
             close
            "
          />
        </q-td>
      </template>

      <template #body-cell-previsao_inicial_entrega="props">
        <q-td>
          <span>{{
            props.row?.pivot?.previsao_inicial_entrega
              ?.split(" ")[0]
              .split("-")
              .reverse()
              .join("/")
          }}</span>
        </q-td>
      </template>

      <template #body-cell-quantidade="props">
        <q-td>
          <div class="row align rap">
            <q-input
              style="min-width: 100px"
              v-if="props.row.edit"
              dense
              v-model="props.row.pivot.amount"
              outlined
              :disable="edicaoBloqueada"
            />
            <span v-if="props.row.edit == false || props.row.edit == undefined">
              {{ formatQuantidade(props.row.pivot.amount) }}</span
            >

            <q-btn
              v-if="aprovacao == 'pendente' || status == 'Criado'"
              @click="
                props.row.edit
                  ? editarQuantidade(props.row)
                  : (props.row.edit = true)
              "
              round
              flat
              :disable="aprovacao != 'pendente' || status != 'Criado' || edicaoBloqueada"
              :color="props.row.edit ? 'positive' : 'primary'"
              :icon="props.row.edit ? 'sym_o_done_outline' : 'sym_o_edit'"
            >
              <q-tooltip v-if="edicaoBloqueada">
                Edição bloqueada: pedido possui contrato vinculado
              </q-tooltip>
            </q-btn>
            <q-btn v-else round flat disable color="negative" icon="close" />
          </div>
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md" v-if="rows.length > 0">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>

    <q-btn
      @click="confirmarEnviarProdutos"
      class="q-ml-md q-mt-lg"
      label="Enviar"
      v-if="aprovacao == 'aprovado' && status == 'Criado'"
      no-caps
      style="border-radius: 8px; background-color: #21324a; color: white"
      icon="done"
    >
    </q-btn>

    <DialogConfirmDesign
      :exibir="modalEnviarProdutos"
      mensagem="Tem certeza que deseja enviar esse pedido? Essa ação é irreversivel"
      @resultado="handleEnviarProdutosConfirmacao"
    />
  </div>
</template>

<script>
// funçao para formatar quantidade (minimo 2 casas decimais, maximo 4)
const formatQuantidade = (value) => {
  if (!value && value !== 0) return "0,00";
  const num = Number(value);
  if (isNaN(num)) return "0,00";
  
  let formatted = num.toFixed(4);
  
  const parts = formatted.split('.');
  if (parts.length === 2) {
    let decimals = parts[1];
    while (decimals.length > 2 && decimals[decimals.length - 1] === '0') {
      decimals = decimals.slice(0, -1);
    }
    formatted = parts[0] + '.' + decimals;
  }
  
  return formatted.replace('.', ',');
};

// funcao para formatar preço (R$ com minimo 2 casas decimais, maximo 4)
const formatPreco = (value) => {
  if (!value && value !== 0) return "R$ 0,00";
  const num = Number(value);
  if (isNaN(num)) return "R$ 0,00";
  
  let formatted = num.toFixed(4);
  
  const parts = formatted.split('.');
  if (parts.length === 2) {
    let decimals = parts[1];
    while (decimals.length > 2 && decimals[decimals.length - 1] === '0') {
      decimals = decimals.slice(0, -1);
    }
    formatted = parts[0] + '.' + decimals;
  }
  
  return `R$ ${formatted.replace('.', ',')}`;
};

const columns = [
  {
    name: "remover",
    label: "Remover",
    field: "remover",
    align: "left",
  },
  {
    name: "solicitante",
    label: "Solicitante",
    field: (rows) =>
      rows.necessidade_compra && rows.necessidade_compra.solicitante
        ? rows.necessidade_compra.solicitante.nome
        : "Sem solicitante",
    align: "left",
  },
  {
    name: "responsavel_compra",
    label: "Comprador",
    field: (row) => row.responsavel_compra?.nome || "Sem Comprador",
    align: "left",
  },
  {
    name: "code",
    label: "Código",
    field: "code",
    align: "left",
  },

  {
    name: "name",
    label: "Descrição",
    field: "name",
    align: "left",
    style: "max-width: 300px; white-space: normal; word-wrap: break-word; overflow-wrap: break-word;",
  },
  {
    name: "previsao_inicial_entrega",
    label: "Previsão Inicial Entrega",
    field: "previsao_inicial_entrega",
    align: "left",
  },
  {
    name: "previsao_atualizada_entrega",
    label: "Previsão Entrega Atualizada",
    field: "previsao_atualizada_entrega",
    align: "left",
  },
  {
    name: "measurement_unit",
    label: "Unidade	Medida",
    field: (row) => row.stock?.[0]?.pivot?.measurement_unit || row.pivot?.measurement_unit || row.measurement_unit,
    align: "left",
  },
  {
    name: "ncm",
    label: "NCM",
    field: "ncm",
    align: "left",
  },
  {
    name: "acao",
    label: "Preço",
    field: (row) =>
      row.pivot && row.pivot.price
        ? formatPreco(row.pivot.price)
        : "Sem preço",
    align: "left",
  },
  {
    name: "quantidade",
    label: "Quantidade",
    field: "quantidade",
    align: "left",
  },
  {
    name: "acao",
    label: "Total",
    field: (row) =>
      row.pivot.price && row.pivot.amount
        ? formatPreco(row.pivot.price * row.pivot.amount)
        : "Sem total",
    align: "left",
  },
  {
    name: "contrato",
    label: "Contrato",
    field: "contrato",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
import DialogConfirmDesign from "../../../../components/DialogConfirmDesign.vue";

export default {
  components: { DialogConfirmDesign },
  props: ["att", "edicaoBloqueada"],
  setup(props, { emit }) {
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const disable = ref(true);
    const title = ref({
      pedido: "",
      vendorName: "",
      criadoEm: "",
      status: "",
    });
    const route = useRoute();
    const id = route.params.id;
    const ativos = ref([]);
    const dataEntregaAtualizada = ref("");
    const modalEnviarProdutos = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 25,
      rowsNumber: 15,
    });
    const aprovacao = ref(null);
    const status = ref(null);
    const disableToggle = ref(false);
    const myLocale = {
      days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
      daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
      months:
        "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
          "_"
        ),
      monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
      firstDayOfWeek: 1,
    };
    const getDados = async () => {
      try {
        const response = await store.dispatch("compras/pedidoEspecifico", {
          id: id,
        });

        rows.value = response.data.message.products.sort((a, b) => {
          const nameA = (a.name || "").toLowerCase();
          const nameB = (b.name || "").toLowerCase();
          return nameA.localeCompare(nameB, "pt-BR");
        });

        aprovacao.value = response.data.message.aprovacao;
        status.value = response.data.message.status;

        title.value = `Pedido: ${
          response.data.message.provider != null
            ? response.data.message.provider.business_name
            : ""
        } | ${
          response.data.message.vendor.name
        } - Criado em: ${response.data.message.created_at
          .split(" ")[0]
          .split("-")
          .reverse()
          .join("/")} | Status: ${response.data.message.status}`;
        title.value = {
          pedido:
            response.data.message.provider != null
              ? response.data.message.provider.business_name
              : "",
          vendorName: response.data.message.vendor.name,
          criadoEm: response.data.message?.created_at
            .split(" ")[0]
            .split("-")
            .reverse()
            .join("/"),
          status: response.data.message.status,
        };

        disable.value = false;

        rows.value.forEach((e) => {
          if (e.pivot.contrato == 1) {
            ativos.value.push(e.pivot.uuid);
          }
        });
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro a o encontrar produtos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const remover = async (uuid) => {
      try {
        await store.dispatch("compras/removerProduto", {
          products: [{ uuid: uuid }],
          purchase_id: id,
        });

        $q.notify({
          message: "Removido com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro a o remover",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const logs = async (uuid) => {
      try {
        await store.dispatch("compras/logs", {
          pedido_id: id,
          produto_id: uuid,
        });

        $q.notify({
          message: "Log solicitado",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro a o solicitar log",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const jobs = async (uuid) => {
      try {
        await store.dispatch("compras/jobs", {
          products: [{ uuid: uuid }],
          payload: [{ pedido_id: id, itens: [{ id: uuid }] }],
        });

        $q.notify({
          message: "Reenvio de intregação feito com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro a o fazer reenvio de integraçao",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    const active = async (data, event) => {
      try {
        console.log(event.currentTarget.ariaChecked);
        disableToggle.value = true;
        if (event.currentTarget.ariaChecked == "false") {
          await store.dispatch("compras/ativarContrato", {
            purchase_id: id,
            products: [
              {
                amount: data.pivot.amount,
                contrato: 1,
                id: data.id,
                price: data.pivot.price,
                uuid: data.pivot.uuid,
              },
            ],
          });
          $q.notify({
            message: "Atualizado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        } else if (event.currentTarget.ariaChecked == "true") {
          await store.dispatch("compras/ativarContrato", {
            purchase_id: id,
            products: [
              {
                amount: data.pivot.amount,
                contrato: 0,
                id: data.id,
                price: data.pivot.price,
                uuid: data.pivot.uuid,
              },
            ],
          });

          $q.notify({
            message: "Atualizado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        disableToggle.value = false;
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro a o configurar contrato",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const confirmarEnviarProdutos = () => {
      modalEnviarProdutos.value = true;
    };

    const handleEnviarProdutosConfirmacao = async (confirmado) => {
      modalEnviarProdutos.value = false;
      if (confirmado) {
        await enviarProdutos();
      }
    };

    const enviarProdutos = async () => {
      try {
        await store.dispatch("compras/shippedProdutos", {
          purchase_id: id,
        });

        disable.value = false;
        getDados();
        emit("atualizar");
        $q.notify({
          message: "Enviado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o enviar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const editarProdutos = async (row, dataEntregaAtualizada) => {
      row.editAtualizada = false;
      row.pivot.previsao_atualizada_entrega = dataEntregaAtualizada;
      try {
        await store.dispatch("compras/editarProduto", {
          purchase_id: id,
          products: [
            {
              id: row.id,
              previsao_atualizada_entrega: dataEntregaAtualizada
                ?.split("/")
                .reverse()
                .join("-"),
            },
          ],
        });

        disable.value = false;
        getDados();

        $q.notify({
          message: "Editado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o editar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const editarQuantidade = async (row) => {
      row.edit = false;

      try {
        await store.dispatch("compras/editarProdutoQuantidade", {
          purchase_id: id,
          products: [
            {
              id: row.id,
              amount: Number(row.pivot.amount).toFixed(2),
              price: Number(row.pivot.price).toFixed(2),
              uuid: row.pivot.uuid,
            },
          ],
        });

        disable.value = false;
        getDados();

        $q.notify({
          message: "Editado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o editar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => props.att,
      () => {
        getDados();
      }
    );

    return {
      pagination,
      rows,
      disable,
      columns,
      title,
      getDados,
      handleRequest,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      remover,
      logs,
      jobs,
      active,
      ativos,
      enviarProdutos,
      disableToggle,
      editarProdutos,
      dataEntregaAtualizada,
      editarQuantidade,
      myLocale,
      aprovacao,
      status,
      formatQuantidade,
      formatPreco,
      modalEnviarProdutos,
      confirmarEnviarProdutos,
      handleEnviarProdutosConfirmacao,
    };
  },
};
</script>

<style scoped>
.align {
  align-items: center;
}

.rap {
  flex-wrap: nowrap !important;
}
tbody tr td {
  white-space: pre-wrap;
}
</style>
